export const TYPE_BADGE_STYLES = {
    Maintenance: 'tw-bg-blue-50 tw-text-blue-600',
    Payment: 'tw-bg-emerald-50 tw-text-emerald-600',
    Amenities: 'tw-bg-purple-50 tw-text-purple-600',
    Penalty: 'tw-bg-orange-50 tw-text-orange-600',
};

export const TRANSACTION_TYPES = [
    { value: 'all', label: 'All Transactions' },
    { value: 'Maintenance', label: 'Maintenance' },
    { value: 'Payment', label: 'Payment' },
    { value: 'Amenities', label: 'Amenities' },
    { value: 'Penalty', label: 'Penalty' },
];

// Sample data for UI preview (replace with API data)
export const SAMPLE_LEDGER = [
    { date: '01 Oct 2023', description: 'Opening Balance Carried Forward', type: null, refNo: null, debit: null, credit: null, balance: 2450.00, isOpening: true },
    { date: '05 Oct 2023', description: 'Monthly Maintenance - Oct 2023', type: 'Maintenance', refNo: '-', debit: 4500.00, credit: 0.00, balance: 6950.00 },
    { date: '10 Oct 2023', description: 'Payment via UPI - Ref: 329048...', type: 'Payment', refNo: 'UPI/82910', debit: 0.00, credit: 5000.00, balance: 1950.00 },
    { date: '15 Oct 2023', description: 'Gym & Clubhouse Usage Charges', type: 'Amenities', refNo: '-', debit: 1200.00, credit: 0.00, balance: 3150.00 },
    { date: '05 Nov 2023', description: 'Monthly Maintenance - Nov 2023', type: 'Maintenance', refNo: '-', debit: 4500.00, credit: 0.00, balance: 7650.00 },
    { date: '12 Nov 2023', description: 'Payment - HDFC Bank Transfer', type: 'Payment', refNo: 'FT/092102', debit: 0.00, credit: 7000.00, balance: 650.00 },
    { date: '05 Dec 2023', description: 'Monthly Maintenance - Dec 2023', type: 'Maintenance', refNo: '-', debit: 4500.00, credit: 0.00, balance: 5150.00 },
    { date: '15 Dec 2023', description: 'Late Payment Penalty - Oct/Nov', type: 'Penalty', refNo: '-', debit: 1000.00, credit: 0.00, balance: 6150.00 },
    { date: '20 Dec 2023', description: 'Payment - ICICI Cheque #902120', type: 'Payment', refNo: 'CHQ-902120', debit: 0.00, credit: 3000.00, balance: 3150.00 },
];

export const formatCurrency = (amount) => {
    if (amount === null || amount === undefined) return '';
    return new Intl.NumberFormat('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(amount);
};
